module.exports = __webpack_public_path__ + "static/callto-bg-72e59a7c277cb2b73b2836a3b15a7574.jpg";